import mitt from 'mitt'

/**
 * 统一管理事件名，避免多个文件散落裸字符串，后续若改名只需要维护这一处。
 */
export const TASK_LIST_UPDATED_EVENT = 'task-list-updated'
export const MESSAGE_DELETED_SYNC_EVENT = 'message-delete-state-updated'

/**
 * 全局事件总线（mitt）
 * 替代 Vue2 中的 this.$root.$emit / this.$root.$on 模式
 * 用法：
 *   emitter.emit('事件名', 数据)      // 触发事件
 *   emitter.on('事件名', handler)     // 监听事件
 *   emitter.off('事件名', handler)    // 取消监听
 */
export const emitter = mitt()
